import * as OrderTexts from '../../../../../../../../intl'

export default function validateLoadField(
  loads: Record<string, number>,
): Record<string, { name?: string; value?: string }> {
  const customFieldsErrors: Record<string, { name?: string; value?: string }> = Object.entries(
    loads,
  ).reduce((acc: Record<string, { name?: string; value?: string }>, [key, value]) => {
    const isEmptyKey = key.trim() === ''
    const isEmptyValue = value === null || value <= 0 || isNaN(value)
    if (isEmptyKey || isEmptyValue) {
      acc[key] = {
        name: isEmptyKey ? OrderTexts.getValidationErrorLoadName() : undefined,
        value: isEmptyValue ? OrderTexts.getValidationErrorLoadValue() : undefined,
      }
    }
    return acc
  }, {})
  return customFieldsErrors
}
